import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import AdvWidgetBannerList from "./AdvWidgetBannerList";
import { useAdBanners } from "../../util/useAdBanners";

const FALLBACK_BANNERS = [
  {src : '/static/img/banner/main/001.png', to : 'https://open.kakao.com/o/slfmVBvi', target:"_blank"},
  {src : '/static/img/banner/main/002.png', to : '/consulting'},
  {src : '/static/img/banner/main/003.png', to : '/expert'},
];

const FALLBACK_RIGHT_TOP_BANNER = [
	[{src : '/static/img/main_banner_01.png', to : 'https://dashboard.mbizsquare.com/', target:"_blank"}],
	[{src : '/static/img/main_banner_02.png', to : '/placeRank'}],
];

const FALLBACK_RIGHT_BANNER = [
	[{src : '/static/img/banner/main/right/1-001.gif', to : 'https://open.kakao.com/o/slfmVBvi', target:"_blank"}],
	[
		{src : '/static/img/banner/main/right/2-001.png', to : 'http://pf.kakao.com/_QIxlTK/chat', target:"_blank"},
		{src : '/static/img/banner/main/right/2-002.png', to : 'http://pf.kakao.com/_Izxnxgn/chat', target:"_blank"},
	],
];

const HomeBanner = ({ hideSideBanner = false }) => {
    const navigate = useNavigate();
    const { items: banners } = useAdBanners('main_carousel', { items: FALLBACK_BANNERS });
    const { groups: rightTopBanner } = useAdBanners('main_right_top', { groups: FALLBACK_RIGHT_TOP_BANNER });
    const displayBanners = banners?.length ? banners : FALLBACK_BANNERS;
    const displayRightTop = rightTopBanner?.length ? rightTopBanner : FALLBACK_RIGHT_TOP_BANNER;

    const handleBannerClick = banner => {
      if (!banner.to) return;
      if (!banner.target) {
        return navigate(banner.to);
      }
      const newWindow = window.open(banner.to, "_blank");
        if (newWindow) {
            newWindow.focus();
        } else {
            alert("팝업 차단 설정이 활성화되어 새 창을 열 수 없습니다.");
        }
    }

	useEffect(() => {
		const banner_swiper = new window.Swiper("#banner-slide", {
			slidesPerView: 1,
			spaceBetween: 0,
			loop: displayBanners.length > 1,
			autoplay: displayBanners.length > 1 ? { delay: 3000 } : false,
			pagination: {
		        el: '.swiper-pagination',
		        clickable: true
		    }
		});
		return () => {
			if (banner_swiper) banner_swiper.destroy();
		}
	}, [displayBanners.length])

	return (
		<>
			<div className="content-banner">
				<div className="swiper-container center-banner-section" id="banner-slide">
					<div className="swiper-wrapper">
						{displayBanners.map((b, idx) =>
							<div className="swiper-slide" key={`${b.src}-${idx}`}>
								<img src={b.src} alt="배너" className="pc_only" onClick={() => handleBannerClick(b)}/>
								<img src="/static/img/dump_banner_main_mo.png" alt="배너" className="nonpc_only" />
							</div>
						)}
					</div>
					<div className="swiper-pagination"></div>
				</div>
			</div>
			{!hideSideBanner && <div className="content-banner-col pc_only">
				<AdvWidgetBannerList bannerGroups={displayRightTop} ratio={"2.6/1"} />
			</div>}			
		</>
	)
}

const HomeSectionBanner = () => {
    const { groups: rightBanner } = useAdBanners('main_right', { groups: FALLBACK_RIGHT_BANNER });
    const displayRightBanner = rightBanner?.length ? rightBanner : FALLBACK_RIGHT_BANNER;

    return (
        <div className="content-banner-col pc_only">
            <AdvWidgetBannerList bannerGroups={displayRightBanner} />
        </div>
    );
};

export { HomeSectionBanner, FALLBACK_RIGHT_BANNER as RIGHT_BANNER };
export default HomeBanner;
